import { BA200 } from '../components/SideBar/constants';

export const writeToLocalStorage = (key, value) => {
  const store = JSON.parse(localStorage.getItem('intellidex') || '{}');
  localStorage.setItem(
    'intellidex',
    JSON.stringify({
      ...store,
      [key]: value,
    }),
  );
};

function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const getFromLocalStorage = (key) => {
  const store = JSON.parse(localStorage.getItem('intellidex') || '{}');
  return store[key];
};

export function transformQuarterString(input) {
  const match = input.match(/^(\d{4})(Q[1-4])$/);
  if (!match) {
    return `${input.slice(5, 7)}/${input.slice(2, 4)}`;
  }

  const year = match[1];
  const quarter = match[2];

  return `${quarter}/${year}`;
}

export const clearLocalStorage = () => {
  localStorage.setItem(
    'intellidex',
    JSON.stringify({ accessToken: null, refreshToken: null, userRole: null, userName: null }),
  );
};

export const getFormatedData = (data, format = 'YYYY-MM') => {
  const date = data.format(format);
  return date;
};

export const getDbKeys = (bds, databases) =>
  databases
    .filter((database) => bds.includes(database.bdid))
    .map((database) => database.key)
    .join(',');

export const getValuesFromKeys = (keys) =>
  keys.map((key) => {
    const value = key.split('-');
    return { column: value[0], row: value[1], table: value[2], infoRow: value[3] };
  });

export function flatten(list = []) {
  const result = [];
  list.forEach((item) => {
    result.push(item);
    if (item.children) {
      result.push(...flatten(item.children));
    }
  });
  return result;
}

export const getSelectedPairs = (treeData, values, columns) =>
  values.reduce((accum, item) => {
    let column;
    treeData.forEach((table) => {
      if (table.key === Number(item.table) && table) {
        column = table?.children
          .filter((row) => row.key.split('t')[0] === item.row)[0]
          .children.filter(({ key }) => key.split('-')[0] === item.column)[0];
      }
    });
    if (accum[`${item.table}-${item.row}`]) {
      return {
        ...accum,
        [`${item.table}-${item.row}`]: [
          ...accum[`${item.table}-${item.row}`],
          `${columns[item.column - 1]?.columnnumber} - ${column?.title}`,
        ],
      };
    }
    return {
      ...accum,
      [`${item.table}-${item.row}`]: [
        `${columns[item.column - 1]?.columnnumber} - ${column?.title}`,
      ],
    };
  }, {});

export const parseTargetKeys = (tablesData, db) => {
  if (db.includes('private_banks')) {
    const values = Object.values(tablesData[0]);
    const keys = Object.keys(tablesData[0]).reduce((acc, table, index) => {
      const formattedKey = capitalizeFirstLetter(
        table.includes('_') ? table.replace(/_/g, ' ') : table,
      );
      const value = values[index];
      if (Array.isArray(value)) {
        value.forEach((v) => acc.push(`${formattedKey}:${v}`));
      } else {
        acc.push(`${formattedKey}:${value}`);
      }

      return acc;
    }, []);
    return keys;
  }
  if (db.includes('consumer_credit')) {
    const keys = tablesData.reduce((acc, table) => {
      const sheetNumber = table.sheet_number;
      const blockType = table.block_type;
      const totalSumValue = table.total_sum_value;
      const { agreement } = table;
      const formattedKey = `${sheetNumber}-${blockType}-${totalSumValue}-${agreement}`;
      acc.push(formattedKey);
      return acc;
    }, []);
    return keys;
  }
  const keys = tablesData.reduce((acc, table) => {
    table.rows.forEach((row) => {
      row.columns.forEach((column) => {
        acc.push(db.includes(BA200) ? `1-1-${row.id}` : `${column}-${row.id}-${table.table_id}`);
      });
    });
    return acc;
  }, []);
  return keys;
};
